/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'report': {
    width: 19,
    height: 22,
    viewBox: '0 0 19 22',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M13.664.775l4.25 4.173a.61.61 0 01.182.435v13.743a2.276 2.276 0 01-2.274 2.274H2.495A2.276 2.276 0 01.22 19.126V2.874A2.276 2.276 0 012.494.6h10.743a.61.61 0 01.427.175zm2.333 3.999l-2.15-2.112V4.58c0 .107.087.194.194.194h1.956zm-.175 15.407H2.495a1.056 1.056 0 01-1.055-1.055V2.874c0-.582.473-1.055 1.055-1.055h10.134v2.76c0 .78.634 1.413 1.413 1.413h2.836v13.134c0 .582-.473 1.055-1.054 1.055zM4.799 10.27h8.59a.61.61 0 010 1.219h-8.59a.61.61 0 110-1.22zm0 3.656h7.005a.61.61 0 100-1.219H4.798a.61.61 0 100 1.219zm0 1.219h7.85a.61.61 0 010 1.219h-7.85a.61.61 0 110-1.22z" _fill="#1D3861"/>'
  }
})
